import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp, FaFacebook, FaInstagram, FaVk, FaTwitter, FaTelegram } from 'react-icons/fa';




const Footer = () => {
    var formFooterName = '' 
    var formFooterPhone = '' 
    function handleChangeFooterName(e) {
        formFooterName = e.target.value;
    }
    function handleChangeFooterPhone(e) {
        formFooterPhone = e.target.value;
    }
    const handleFooterForm = () => {
        if (formFooterPhone === '') {
            alert('Пожалуйста заполните поле Телефон')
        } else if (formFooterName === '') {
            alert('Пожалуйста заполните поле Имя')
        } else {
            fetch('https://sinomost.kz', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formFooterName,
                    phone: formFooterPhone,
                    backlink: 'https://sinomost.kz',
                    interest: 'Форма в подвале сайта',
                })
            });

            alert('Благодарим Вас за проявленный интерес. Мы свяжемся с Вами в самое ближайшее время.')
        }
    }


    const handleMsgAction = (msg) => {
        fetch('https://sinomost.kz/tgmsg/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                tgmsg: msg,
            })
        });
    }


    return (
        <Container className="text-white" fluid>
            <Row className="pt-5">
                <Col className="mb-3" sm={6} lg={3}>
                    <h4>Реквизиты:</h4>
                    <FaMapMarkerAlt /> Адрес: РК, г. Алматы, Микрорайон Мадениет, 171<br />
                    <FaPhone /> Телефоны: <a className="text-primary" onClick={() => {handleMsgAction('Звонок по кнопке в подвале\n' + new Date());window.location.href="#"}} target="_blank" href="tel:+77015471529">+7&nbsp;701&nbsp;547-1529</a> <br />
                    <FaWhatsapp /> Whatsapp: <a className="text-primary" onClick={() => {handleMsgAction('Написать в whatsapp по кнопке в подвале\n' + new Date());window.location.href="#";}} target="_blank" href="https://wa.me/77015471529">+7&nbsp;701&nbsp;547-1529</a> <br />
                    <FaEnvelope /> Почта: info@sinomost.kz <br />
                    <hr />
                    Соц. сети: <br />
                    <a href="https://facebook.com/sinomost.kz"><FaFacebook /></a> <a href="https://instagram.com/sinomost_official"><FaInstagram /></a> <a href="https://vk.com/sinomost"><FaVk /></a> <a href="https://twitter.com/sinomost"><FaTwitter /></a> <a href="https://t.me/sinomost"><FaTelegram /></a>
                </Col>
                <Col className="mb-3" sm={6} lg={3}>
                    <h4>Ссылки</h4>
                    <ul>
                        <li><a href="/about">О Нас</a></li>
                        {/*<li><a href="/marketing">Партнерам</a></li>*/}
                        <li><a href="https://baic.kz">BAIC</a></li>
                        {/*<li><a href="https://dong-feng.kz">Dongfeng</a></li>*/}
                        <li><a href="https://rexlama.kz">Разработчик</a></li>
                    </ul>
                </Col>
                <Col className="mb-3" sm={6} lg={3}>
                    <h4>Документация</h4>
                    <ul>
                        <li><a href="/documents/certificates">Сертификаты</a></li>
                        <li><a href="/documents/requisites">Реквизиты</a></li>
                        <li><a href="/documents/public_offer">Публичная оферта</a></li>
                        <li><a href="/documents/privacy_policy">Политика конфеденциальности</a></li>
                        <li><a href="/documents/delivery">Доставка</a></li>
                        <li><a href="/documents/payment">Оплата</a></li>
                        <li><a href="/documents/user_agreement">Договор с конечным пользователем</a></li>
                    </ul>
                </Col>
                <Col className="mb-3" sm={6} lg={3}>
                    <h4>Обратная связь</h4>


                    <Form>
                        <Form.Group className="mb-3" controlId="formControlProductPhone">
                            <Form.Label>Ваш номер</Form.Label>
                            <Form.Control type="phone" name="phone" onChange={handleChangeFooterPhone} placeholder="+7(123)4567890" required />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formControlProductName">
                            <Form.Label>Ваше имя</Form.Label>
                            <Form.Control type="text" name="name" onChange={handleChangeFooterName} placeholder="_______" required />
                        </Form.Group>
                        <Button variant="primary" type="button" onClick={handleFooterForm}>
                            Оставить заявку
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default Footer;
